export const PaidTemplate = {
    name: 'paid',
    label: 'Paid',
    subject: "REBIT ${reference}: Your payment received!",
    category: 'compulsory',
    body: "<p>🏦 Thanks for the payment of ${paid_amount} ${origin_currency}, ${payer_name}!</p>"
        + "<p>➡️ Our operators in ${dest_country_name} are now working on your order with the reference ${reference}.</p>"
        + "<p>⌚ Estimated transfer time to receive ${dest_currency} is ${transfer_time}. More details in <a href='https://my.rebitmoney.com/help-and-support/tracking'>Help & Support - Tracking</a>.</p>"
        + "<p style='padding:20px;text-align: center'>"
        + "<a href='https://my.rebitmoney.com/transfers/history' style='padding:10px;background-color: #4e54c8;color: white;border-radius: 4px;text-decoration: none'>TRACK YOUR ORDER</a>"
        + "</p>"
}

